import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewLoan} from "../../../../_reducers/activitySlice";
import {setNewLoan} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {Col, Row} from "react-bootstrap";
import AccountingBox from "../../../primer/AccountingBox";
import moment from "moment/moment";
import DateBox from "../../../primer/DateBox";
import Input from "../../../common/Input";
import {constructInstitutesOptions} from "../Banking/constants";
import axios from "axios";
import Dropdown from "../../../primer/Dropdown";
import {checkPermissionStartingTree} from "../../../../_helpers/commonFunctions";

const NewLoan = ({bankingLockFields = false}) => {
    const dispatch = useDispatch();
    const saveNewLoan = useSelector((state) => state.ACTIVITY.saveNewLoan);
    const newLoan = useSelector((state) => state.CASH_DATA.newLoan);

    const [institutes, setInstitutes] = useState([]);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const instituteOptions = constructInstitutesOptions(institutes, permissionsData);

    useEffect(() => {
        fetchInstitutes();
    }, []);

    const handleOnChange = (e, type, name) => {
        if (!saveNewLoan) dispatch(setSaveNewLoan(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "db") {
            if (moment(e).isValid()) prepChange[name] = moment(e).toDate();
            else prepChange[name] = "";
        } else if (type === "ab") {
            let val = e.target.value;
            if (isNaN(+val) || +val <= 0) val = 0;
            else val = +Number(val).toFixed(2);
            prepChange[name] = val;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        }
        dispatch(setNewLoan({...newLoan, ...prepChange}));
    }

    const fetchInstitutes = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-institutes`, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                setInstitutes([
                    {id: "PRXBGRAA", name: "Viva Bank"},
                    ...res.data.data,
                ]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <div className={"mb-3"}>
            <Row>
                <Col md={3}>
                    <Dropdown
                        className={"mb-2"}
                        name={"bank_institute"}
                        label={"Τραπεζικό Ίδρυμα"}
                        options={instituteOptions}
                        required={true}
                        key={newLoan.bank_institute}
                        defaultValue={instituteOptions.find((el) => el.value === newLoan.bank_institute)}
                        onChange={(e) => handleOnChange(e, "dd", "bank_institute")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"numbering"}
                        label={"Κωδικός Δανείου"}
                        required={true}
                        value={newLoan.numbering}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "numbering")}
                    />
                </Col>
                <Col md={3}>
                    <label>Ποσό Κεφαλαίου (€)</label>
                    <AccountingBox
                        name={"amount"}
                        key={newLoan.principal}
                        defaultValue={newLoan.principal}
                        required={true}
                        disabled={bankingLockFields}
                        onBlur={(e) => handleOnChange(e, "ab", "principal")}
                    />
                </Col>
                <Col md={3}>
                    <label>Επιτόκιο Δανεισμού (%)</label>
                    <AccountingBox
                        name={"interestRate"}
                        key={newLoan.interestRate}
                        defaultValue={newLoan.interestRate}
                        suffix={"%"}
                        required={true}
                        onBlur={(e) => handleOnChange(e, "ab", "interestRate")}
                    />
                </Col>
                <Col md={3}>
                    <DateBox
                        name={"startDate"}
                        label={"Ημερομηνία Έναρξης"}
                        selected={moment(newLoan.startDate).isValid() ? moment(newLoan.startDate).toDate() : null}
                        allowOtherYears={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "db", "startDate")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"years"}
                        label={"Διάρκεια σε έτη"}
                        type={"number"}
                        required={true}
                        value={newLoan.years}
                        onChange={(e) => handleOnChange(e, "input", "years")}
                    />
                </Col>
                {checkPermissionStartingTree("accounting", permissionsData) && (
                    <Col md={3}>
                        <Input
                            name={"accounting"}
                            label={"Λογιστικός Λογαριασμός"}
                            value={newLoan.accounting}
                            autoComplete={"off"}
                            disabled={bankingLockFields}
                            onChange={(e) => handleOnChange(e, "input", "accounting")}
                        />
                    </Col>
                )}
            </Row>
        </div>
    )
}

export default NewLoan;
